import { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';

import { eliminarRenta } from '../../actions/locatarios';

const EliminarRenta = ({ renta, reestablecerRenta }) => {

    const dispatch =  useDispatch();

    const [eliminarModal, setEliminarModal] = useState(false);
    const [statusProcesar, setStatusProcesar] = useState(false);

    /* Eliminar renta */
    const handleProcesar = async () => {
        await setStatusProcesar(true);

        await dispatch(eliminarRenta({
            id: renta?._id, 
            id_locatario: renta?.id_locatario
        }));

        await handleCerrar();
        await setStatusProcesar(false);
    }

    const handleCerrar = () => {
        if(!statusProcesar){
            reestablecerRenta(null);
            setEliminarModal(false);
        }
    }

    useEffect(() => {
        if(renta){
            setEliminarModal(true);
        }
    }, [renta]);

    return (
        <Modal show={eliminarModal} backdrop="static" centered onHide={() => handleCerrar()}>
            <Modal.Header closeButton>
                <Modal.Title>Eliminar pago de renta</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>¿Deseas eliminar el pago de renta{renta?.fecha ? ' del ' + new Date(renta?.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) : ''}?</p>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn btn-danger mr-3" onClick={() => handleCerrar()} disabled={ statusProcesar }><i className="fas fa-times fa-sm"></i> No</button>
                {
                    statusProcesar ?
                        <button type="button" className="btn btn-success" disabled><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Si</button>
                    :
                        <button type="button" className="btn btn-success" onClick={() => handleProcesar()}><i className="fas fa-check fa-sm"></i> Si</button>
                }
            </Modal.Footer>
        </Modal>
    )
}

export default EliminarRenta;